import { render, staticRenderFns } from "./TeamDetailsCard.vue?vue&type=template&id=221389d5&scoped=true&"
import script from "./TeamDetailsCard.vue?vue&type=script&lang=ts&"
export * from "./TeamDetailsCard.vue?vue&type=script&lang=ts&"
import style0 from "./TeamDetailsCard.vue?vue&type=style&index=0&id=221389d5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221389d5",
  null
  
)

export default component.exports